import { AiOutlineBarcode } from 'react-icons/ai';
import { FaBan, FaBriefcase, FaChartBar, FaClock, FaCog, FaDatabase, FaDollarSign, FaDownload, FaEnvelope, FaEye, FaFile, FaFolder, FaHandshake, FaHome, FaInfoCircle, FaMoneyBill, FaUpload, FaUsers, FaYoutube } from "react-icons/fa";
import { FaList, FaWallet } from "react-icons/fa6";

const menuParceiro = [
    {
        label: "MENU",
        items: [
            { label: "Visão Geral", icon: <FaHome />, to: "/dashboard" },
            {
                label: "Cobranças",
                icon: <FaMoneyBill/>,
                items: [
                    { label: "Gerar", icon: <FaFile/>, to: "/dashboard/gerar" },
                    { label: "Listagem", icon: <FaList/>, to: "/dashboard/negociacoes" },
                    { label: "Importações Inadimplentes", icon:  <FaInfoCircle/>, to: "/dashboard/inadimplentes" },
                ],
            },
            {
                label: "Importações",
                icon: <FaUpload/>,
                items: [{ label: "Importar", icon: <FaWallet/>, to: "/dashboard/importar" }],
            },
            {
                label: "Relatórios",
                icon: <FaFolder/>,
                items: [
                    { label: "Protestados", icon: <FaBan/>, to: "/dashboard/relatorioprotestados" },
                    { label: "Baixas", icon: <FaDownload/>, to: "/dashboard/relatoriobaixas" },
                    { label: "Negociações", icon: <FaMoneyBill/>, to: "/dashboard/relatorionegociacoes" },
                    { label: "Comunicados Pós-Negociação", icon: <FaEnvelope/>, to: "/dashboard/relatorioComnNegociados" },
                    { label: 'Registro de Ações', icon: <FaList/>, to: '/dashboard/relatorioAcoes' },
                    { label: 'Higienizados', icon: <FaDatabase/>, to: '/dashboard/higienizados' }
                ],
            },
            { label: "Usuários", icon: <FaUsers/>, to: "/dashboard/usuarios" },
            { label: "Estatísticas", icon: <FaChartBar/>, to: "/dashboard/estatisticas" },
        ],
    },
];
const menuCartorio = [
    {
        label: "MENU",
        items: [
            { label: "Visão Geral", icon: <FaHome />, to: "/dashboard" },
            {
                label: "Inadimplências",
                icon: <FaMoneyBill/>,
                items: [{ label: "Listagem", icon: <FaList/>, to: "/dashboard/negociacoes" }],
            },
            {
                label: "Importações",
                icon: <FaUpload/>,
                items: [
                    { label: "Custas Cancelamento", icon: <FaInfoCircle/>, to: "/dashboard/inadimplentes" },
                    { label: "Baixas de Cancelamento", icon: <FaDollarSign/>, to: "/dashboard/baixas" },
                ],
            },
            {
                label: "Relatórios",
                icon: <FaFolder/>,
                items: [
                    { label: "Relatório de Baixas", icon: <FaDownload/>, to: "/dashboard/relatoriobaixas" },
                    { label: "Relatório de Negociações", icon: <FaMoneyBill/>, to: "/dashboard/relatorionegociacoes" },
                    { label: "Comunicados Pós-Negociação", icon: <FaEnvelope/>, to: "/dashboard/relatorioComnNegociados" },
                    // { label: "Relatório Total de Negociados", icon: "pi pi-plus", to: "/dashboard/relatoriototalnegociados" },
                    { label: "Relatório de Boletos a Vencer", icon: <FaClock/>, to: "/dashboard/boletosavencer" },
                    { label: 'Registro de Ações', icon: <FaList/>, to: '/dashboard/relatorioAcoes' },
                ],
            },
            { label: "Estatísticas", icon: <FaChartBar/>, to: "/dashboard/estatisticas" },
            { label: "Usuários", icon: <FaUsers/>, to: "/dashboard/usuarios" },
        ],
    },
];
const menuProviderNegociar = [
    {
        label: "MENU",
        items: [
            { label: "Visão Geral", icon: <FaHome />, to: "/dashboard" },
            {
                label: "Inadimplências",
                icon: <FaMoneyBill/> ,
                items: [
                    { label: "Importar Inadimplências", icon: <FaInfoCircle/>, to: "/dashboard/inadimplentes" },
                    { label: "Gerar", icon: <FaFile/>, to: "/dashboard/gerar" },
                    { label: "Listagem", icon: <FaList/>, to: "/dashboard/negociacoes" },
                ],
            },
            {
                label: "Boleto Inteligente",
                icon: <AiOutlineBarcode />,
                items: [
                    { label: 'Painel', icon: <FaEye/>, to: '/dashboard/adimplencia' },
                    { label: 'Clientes', icon: <FaBriefcase/>, to: '/dashboard/adimplencia/clientes' },
                    { label: 'Boletos', icon: <FaDollarSign/>, to: '/dashboard/adimplencia/boletos' },
                    { label: 'Importar', icon: <FaUpload/>, to: '/dashboard/adimplencia/importar' },
                    { label: 'Parâmetros', icon: <FaCog/>, to: '/dashboard/adimplencia/parametros' },
                ]
            },
            {
                label: "Relatórios",
                icon: <FaFolder/>,
                items: [
                    { label: "Repasses", icon: <FaFile/>, to: "/dashboard/relatorio/REP" },
                    { label: "Protestados", icon: <FaBan/>, to: "/dashboard/relatorio/PTR" },
                    { label: "Baixas", icon: <FaDownload/>, to: "/dashboard/relatorio/BAI" },
                    { label: "Negociações", icon: <FaMoneyBill/>, to: "/dashboard/relatorionegociacoes" },
                    { label: "Receitas", icon: <FaEye/>, to: "/dashboard/relatoriogerencial" },
                    { label: "Boletos a Vencer", icon: <FaClock/>, to: "/dashboard/boletosavencer" },
                    { label: "Comunicados Pós-Negociação", icon: <FaEnvelope/>, to: "/dashboard/relatorioComnNegociados" },
                    { label: 'Registro de Ações', icon: <FaList/>, to: '/dashboard/relatorioAcoes' },
                    { label: 'Dados Atualizados', icon: <FaDatabase/>, to: '/dashboard/higienizados' }
                    // { label: "Histórico de Pagamentos", icon: "pi pi-dollar", to: "/dashboard/historicoPagamento" },
                ],
            },
            { label: "Negocia Direto", icon: <FaHandshake />, to: "/dashboard/negociar" },
            { label: "Estatísticas", icon: <FaChartBar/>, to: "/dashboard/estatisticas" },
            { label: "Usuários", icon: <FaUsers/>, to: "/dashboard/usuarios" },
            { label: "Tutoriais", icon: <FaYoutube/>, to: "/dashboard/tutoriais" },
        ],
    },
];

const menuProvider = [
    {
        label: "MENU",
        items: [
            { label: "Visão Geral", icon: <FaHome />, to: "/dashboard" },
            {
                label: "Inadimplências",
                icon: <FaMoneyBill/>,
                items: [
                    { label: "Importar Inadimplências", icon: <FaInfoCircle/>, to: "/dashboard/inadimplentes" },
                    { label: "Gerar", icon: <FaFile/>, to: "/dashboard/gerar" },
                    { label: "Listagem", icon: <FaList/>, to: "/dashboard/negociacoes" },
                ],
            },
            {
                label: "Boleto Inteligente",
                icon: <AiOutlineBarcode />,
                items: [
                    { label: 'Painel', icon: <FaEye/>, to: '/dashboard/adimplencia' },
                    { label: 'Clientes', icon: <FaBriefcase/>, to: '/dashboard/adimplencia/clientes' },
                    { label: 'Boletos', icon: <FaDollarSign/>, to: '/dashboard/adimplencia/boletos' },
                    { label: 'Importar', icon: <FaUpload/>, to: '/dashboard/adimplencia/importar' },
                    { label: 'Parâmetros', icon: <FaCog/>, to: '/dashboard/adimplencia/parametros' },
                ]
            },
            {
                label: "Relatórios",
                icon: <FaFolder/>,
                items: [
                    { label: "Repasses", icon: <FaFile/>, to: "/dashboard/relatorio/REP" },
                    { label: "Protestados", icon: <FaBan/>, to: "/dashboard/relatorio/PTR" },
                    { label: "Baixas", icon: <FaDownload/>, to: "/dashboard/relatorio/BAI" },
                    { label: "Negociações", icon: <FaMoneyBill/>, to: "/dashboard/relatorionegociacoes" },
                    { label: "Receitas", icon: <FaEye/>, to: "/dashboard/relatoriogerencial" },
                    { label: "Boletos a Vencer", icon: <FaClock/>, to: "/dashboard/boletosavencer" },
                    { label: "Comunicados Pós-Negociação", icon: <FaEnvelope/>, to: "/dashboard/relatorioComnNegociados" },
                    { label: 'Registro de Ações', icon: <FaList/>, to: '/dashboard/relatorioAcoes' },
                    { label: 'Dados Atualizados', icon: <FaDatabase/>, to: '/dashboard/higienizados' }
                    // { label: "Histórico de Pagamentos", icon: "pi pi-dollar", to: "/dashboard/historicoPagamento" },
                ],
            },
            { label: "Negocia Direto", icon: <FaHandshake />, to: "/dashboard/negociar" },
            // { label: "Propostas", icon: <FaExchangeAlt />, to: "/dashboard/propostas" },
            { label: "Estatísticas", icon: <FaChartBar/>, to: "/dashboard/estatisticas" },
            { label: "Usuários", icon: <FaUsers/>, to: "/dashboard/usuarios" },
            { label: "Tutoriais", icon: <FaYoutube/>, to: "/dashboard/tutoriais" },
        ],
    },
];

const listaMenu = {menuCartorio,menuParceiro,menuProvider,menuProviderNegociar}

export default listaMenu